const { result } = require("lodash");

/**
 * ダッシュボードページ用のスクリプト
 */
if (is_route('dashboard.index')) {
    // コンテンツ読み込み後
    $(document).on('amc:onload', function() {
        // if($('input[name=is_unset]').val() == '1'){
        //     _error.systemError('not_belong');
        // }
        dashboard_event_set();
        dashboard_load_contents();
        dashboard_setting_event_set();
    });
    // コンテンツの再読み込み後
    $(document).on('amc:reload', function() {
        dashboard_load_contents();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
window.dashboard_event_set = function () {

    /*---- タスク追加時のバブリングを禁止 ----*/

    // ボタンクリック時のバブリングを禁止
    $(document).on('click', '.information-list .list-group-item .btn[data-toggle=modal]', function (e) {
        e.preventDefault();
        e.stopPropagation();
    });

    /*---- 開いた通知の状態を保持 ----*/

    // 開いた通知の状態を保持
    $(document).on('click', '.information-button', function() {
        let type = $(this).data('type');
        _request.set_parameters([{'name': 'type', 'value': type}]);
    });

    /*---- お知らせの検索処理 ----*/
    // 検索フォームの変更時
    $(document).on('change', '#information-search-form, #information-keyword-search', function(e) {
        // バブリングを禁止
        e.stopPropagation();
        //検索処理
        searchInformation(document);
    });
    // キーワード検索の実行ボタンクリック時
    $(document).on('click', '#information-keyword-search-submit, #information-keyword-search-reset', function(e) {
        // バブリングを禁止
        e.stopPropagation();
        //検索処理
        searchInformation(document);
    });
    // 文字入力時
    $('#information-keyword-search').on('input', function (e) {
        // バブリングを禁止
        e.stopPropagation();
        //検索処理
        searchInformation(document);
    })
    //追加検索
    $(document).on('click', '#information-list-area button', function() {
        let allInfoElement = $('#information-list-area').find('.tab-panel.active .information-list');
        let paginator = $(allInfoElement).find('.infomation-pagenation');
        if ($(paginator).length > 0 && $(paginator).data('loaded') == null && Number(paginator[0].dataset.total) > Number(paginator[0].dataset.current) * 20) {
            $(paginator).show();
            $(paginator).data('loaded', 'loaded');
            dashboard_information_load(allInfoElement, () => searchInformation(document));
        }
        let type = new URLSearchParams(location.search).get('type');
        type = String(!type ? 'user' : type);
        const notFoundElement = document.getElementById('information-search-not-found-' + type);
        const notFoundNextSearchButton  = document.getElementById('information-next-search-' + type);
        const informationFooter = document.getElementById('information-footer');
        notFoundElement.classList.add('d-none');
        notFoundNextSearchButton.classList.add('d-none');
        informationFooter.classList.add('d-none');
    })

    //お知らせ検索処理実行関数
    function searchInformation (document) {
        //検索ワード取得
        const keyword = String(document.getElementById('information-keyword-search').value).toUpperCase();
        //表示されているお知らせの種別を取得（nullの場合はuser）
        let type = new URLSearchParams(location.search).get('type');
        type = String(!type ? 'user' : type);
        //表示されているお知らせのelementを取得
        let informationElement = document.querySelector('#list-information-type-' + type + ' .information-list');
        //ElementのNodeListを取得
        let informationNodeList = Array.from(informationElement.children);

        let notMatchCount = 0;
        let liCount = 0;

        if (keyword) {
            //キーワードがある場合は、抽出処理
            for (let i = 0; i < informationNodeList.length; i++) {
                let info = informationNodeList[i];
                if (info.nodeName == 'LI' && !(info.classList.contains('infomation-pagenation'))) {
                    liCount ++;
                    info.style.display = '';
                    if (info.textContent.trim().toUpperCase().indexOf(keyword) === -1) {
                        info.style.display = 'none';
                        notMatchCount ++;
                    }
                }
            }
        } else {
            //キーワードがない場合は、抽出キャンセル処理
            for (let i = 0; i < informationNodeList.length; i++) {
                let info = informationNodeList[i];
                if (info.nodeName == 'LI' && !(info.classList.contains('infomation-pagenation'))) {
                    info.style.display = '';
                }
            }
        }

        const notFoundElement = document.getElementById('information-search-not-found-' + type);
        const notFoundNextSearchButton  = document.getElementById('information-next-search-' + type);
        const informationFooter = document.getElementById('information-footer');
        let allInfoElement = $('#information-list-area').find('.tab-panel.active .information-list');
        let paginator = $(allInfoElement).find('.infomation-pagenation');

        if (keyword && notMatchCount === liCount && liCount >= 1) {
            notFoundElement.classList.remove('d-none');
            if (paginator.length >= 1 && Number(paginator[0].dataset.total) > Number(paginator[0].dataset.current) * 20) {
                notFoundNextSearchButton.classList.remove('d-none');
                informationFooter.classList.add('d-none');
            }
        } else {
            notFoundElement.classList.add('d-none');
            notFoundNextSearchButton.classList.add('d-none');
            informationFooter.classList.add('d-none');
            if (keyword && paginator.length >= 1 && Number(paginator[0].dataset.total) > Number(paginator[0].dataset.current) * 20) {
                informationFooter.classList.remove('d-none');
            }
        }

        return true;
    }

    //お知らせのtype切り替え時の処理
    $(document).on('click', '#tab-information-type-wrapper a', function() {
        //検索ボックスの値を削除
        document.getElementById('information-keyword-search').value = '';
        //表示リセット
        searchInformation(document);
    });


    /*---- 通知からの設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function() {
        // 設定モーダルを表示
        _modal.create(this, 'setting-modal', ['id', 'type', 'date', 'user_id'], function() {
            attendance_setting_recalculation();
            if ($('.holiday-status-flag:checked').length > 0) {
                attendance_attendance_flag_event($('.holiday-status-flag:checked'));
            }
        });
    });

    /*---- 通知からの画面遷移 ----*/

    // ページ移動
    $(document).on('click', '[data-location]', function() {
        location.href = $(this).data('location');
    });

    /*---- 通知からの設定保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        var modalId = $(this).data('save-modal');
        const formId = create_id($(this).data('save-modal') + '-form');
        // 日時が送信されないと休暇系の算出が行えないためdisabledを解除する
        $.each($(formId).find('[name=work_started_at]:disabled,[name=work_ended_at]:disabled,[name=rest_started_at]:disabled,[name=rest_ended_at]:disabled'), function() {
            $(this).prop('disabled', false);
        });
        _modal.submit(this, 'save-modal', function(results) {
            if (modalId.indexOf('rollcall') >= 0) {
                $('[data-detail-modal=rollcall-detail-modal][data-date=' + moment(results.rollcall.rollcalled_at).format("YYYY-MM-DD") + ']').trigger('click');
            }
        }, function() {
            // ステップエラーを表示
            user_set_steper_error();
            vehicle_set_steper_error();
        });
    });

    /*---- 通知からの点呼設定画面の表示（点呼専用） ----*/

    // 設定表示時（点呼専用）
    $(document).on('click', '[data-detail-modal]', function() {
        // 設定モーダルを表示
        _modal.create(this, 'detail-modal', ['id', 'type', 'date', 'user_id']);
    });

    /*---- 通知からの削除確認時 ----*/

    // 削除確認時
    $(document).on('click', '[data-confirm-modal]', function() {
        // 設定モーダルを表示
        _modal.create(this, 'confirm-modal', ['id']);
    });

    /*---- 通知からの削除時 ----*/

    // 削除時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal', function(results) {
            $('.modal').each(function() {
                _modal.hide($(this));
            });
        });
    });

    /*---- 通知からタスクのドロップ時 ----*/

    // ドロップ時
    $(document).on('drop', '.task-list', function() {
        var dropId = create_id(event.dataTransfer.getData('id'));
        var modalId = $(dropId).data('information-to-task-modal');
        _modal.show(modalId);
    });

    /*---- タスク保存時 ----*/

    // 設定表示時
    $(document).on('click', '[data-task-modal]', function () {
        _modal.submit(this, 'task-modal');
    });

    /*---- タスク削除確認表示時 ----*/

    // 削除確認表示時
    $(document).on('click', '[data-task-confirm-modal]', function () {
        // 詳細モーダルを表示
        _modal.create(this, 'task-confirm-modal', ['id']);
    });

    /*---- タスク削除時 ----*/

    // タスク削除時
    $(document).on('click', '[data-task-delete-modal]', function () {
        _modal.submit(this, 'task-delete-modal', function(results) {
            _modal.hide('#task-setting-' + results.task.id);
        });
    });

    /*---- カレンダーの切り替え時 ----*/

    // カレンダーの切り替え時
    $(document).on('click', '.calendar-date', function() {
        var date = $(this).data('date');
        $('#search-form-current').val(date);
        // 非表示処置
        $('.calendar-date.active').removeClass('active');
        $('.calendar-date-detail').addClass('display-none');
        // 表示処理
        $(this).addClass('active');
        $('.calendar-date-detail[data-date=' + date + ']').removeClass('display-none');
    });

    /*---- タスクからカレンダーへのドロップ時 ----*/

    // スケジュールの登録時（ドロップ）
    $(document).on('drop', '.calendar-date', function(e) {
        let dropId = create_id(event.dataTransfer.getData('id'));
        $(this).data('id', $(dropId).data('id'));
        _modal.create(this, 'task-to-schedule-modal', ['id', 'date']);
        $(this).removeData('id');
    });


    /*---- スケジュール保存時 ----*/

    // スケジュールの登録時
    $(document).on('click', '[data-schedule-modal]', function () {
        var startedAt = moment($(create_id($(this).data('schedule-modal') + '-started_at')).val(), 'YYYY/MM/DD HH:mm');
        $('#search-form-current').val(startedAt.format('YYYY-MM-DD'));
        _modal.submit(this, 'schedule-modal');
    });

    /*---- スケジュール削除確認時 ----*/
    
    // スケジュールの削除確認モーダル
    $(document).on('click', '[data-schedule-confirm-modal]', function () {
        _modal.create(this, 'schedule-confirm-modal', ['id']);
    });

    /*---- スケジュール削除時 ----*/

    // スケジュール削除実行時
    $(document).on('click', '[data-schedule-delete-modal]', function () {
        _modal.submit(this, 'schedule-delete-modal', function(results) {
            _modal.hide('#schedule-setting-' + results.schedule.id);
        });
    });

    /*---- お知らせ完了時 ----*/

    // お知らせ完了ボタンクリック時
    $(document).on('click', '.btn-information-complete', function (e) {
        let datas = [];
        datas.push({'name' : 'id', 'value' : $(this).data('id')});
        // 送信
        _ajax.post($(this).data('action'), datas, function (results) {
            load_contents();
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
        }, 'html');
        // 親要素へのクリックイベント伝搬を回避する
        e.preventDefault();
        e.stopPropagation();
    });

}
/**
 * ページ読み込み時のイベント設定（再読み込みも実行）
 */
window.dashboard_load_contents = function() {

    /*---- お知らせリストの最終項目表示での読み込み処置 ----*/

    // スクロール時
    $('.tab-content').on('scroll', function() {
        var scroll = $(this).scrollTop();
        var height = $(this).outerHeight();
        var scrollHeight = $(this).get(0).scrollHeight;
        // スクロール位置が最終項目まで達した時（100は許容値）
        if (scroll + height + 100 > scrollHeight) {
            let list = $(this).find('.tab-panel.active .information-list');
            let paginator = $(list).find('.infomation-pagenation');
            if ($(paginator).length > 0 && $(paginator).data('loaded') == null) {
                $(paginator).show();
                $(paginator).data('loaded', 'loaded');
                dashboard_information_load(list);
            }
        }
    });

    /*---- お知らせのリスト分最初のページを読み込む ----*/

    // アクティブな項目を読み込み
    $('.dashboard-information .tab-panel.active .information-list').each(function() {
        // 非アクティブな項目はコールバックで読み込む
        dashboard_information_load(this, function() {
            $('.dashboard-information .tab-panel:not(.active) .information-list').each(function() {
                dashboard_information_load(this);
            });
        });
    });

}
/**
 * 設定モーダルのイベント設定
 */
window.dashboard_setting_event_set = function () {
    user_setting_event_set();
    vehicle_setting_event_set();
    attendance_setting_event_set();
    //rollcall_detail_event_set();
    //diagnosis_setting_event_set();

    // スケジュールの開始日時変更時
    $(document).on('change', 'input[name=started_at]', function () {
        let endedAt = $(this).parents('form').find('input[name=ended_at]');
        if ($(endedAt).val() != '' && $(this).val() != '') {
            // 変更前の時間と変更後の時間を取得
            let old = moment.unix($(this).data('old-timestamp'));
            let current = moment($(this).val(), 'YYYY/MM/DD HH:mm');
            // 計算値の加算対象を取得
            let target = moment($(endedAt).val(), 'YYYY/MM/DD HH:mm');
            // 差分を算出し加算する
            let seconds = current.diff(old, 's');
            let calc = target.add(seconds, 's');
            $(endedAt).val(calc.format('YYYY/MM/DD HH:mm'));
        }
    });
}
/**
 * お知らせの非同期取得
 * @param {*} selector 
 */
window.dashboard_information_load = function(selector, callback = null) {
    let datas = [];
    let action = $(selector).data('action');
    let type = $(selector).data('type');
    let page = $(selector).find('.infomation-pagenation').data('next');
    page = (page == null ? 1 : page);
    datas.push({
        'name': 'type', 
        'value': type 
    });
    datas.push({
        'name': 'page', 
        'value': page 
    });
    _ajax.background(action, datas, function (results) {
        $(selector).find('.infomation-pagenation').remove();
        $(selector).append(results);
        let total = $('#information-'+type+'-total').val();
        let badge = create_id($(selector).data('badge_id'));
        let badgeSide = create_id('menu-information-badge-'+type);
        if (total > 0) {
            if(total > 50){
                total = '50+';
            }
            $(badge).text(total)
            $(badge).toggleClass('display-none', false);
            $(selector).find('.information-not-found').toggleClass('display-none', true);
            $(badgeSide).text(total);
            $(badgeSide).toggleClass('display-none', false);
            $(badgeSide).toggleClass('badge-danger', true);
        } else {
            $(badge).toggleClass('display-none', true);
            $(selector).parent().find('.information-not-found').toggleClass('display-none', false);
            $(badgeSide).toggleClass('display-none', true);
            $(badgeSide).toggleClass('badge-danger', false);
        }
        $(selector).data('page', page);
        initialize();
        if (callback != null) {
            callback();
        }
    }, function(xhr, status, errorThrown) {
        _error.omitted(xhr, status, errorThrown);
    }, 'html');
}